import React, { useContext, useState } from 'react';
import { CompanyContext } from '../context/CompanyContext';
import { useNavigate } from 'react-router-dom';
import { validateCompanyUser } from './Validation';
import loginlogo from '../assets/images/loginlogo.png';
import Eye from '../assets/images/passeye.png';
import '../assets/styles/CompanyLogin.css';
import '../assets/styles/RdCompanyLogin.css';
import Productlogo from '../assets/images/Product-logo.svg';
import amhc_logo from '../assets/images/amhc_logo.png';
import MGE from '../assets/images/recreatedsvg2.png';
import GDC_logo from '../assets/images/GDCLogo.svg';
import hayat_logo from '../assets/images/al-hayat-logo.png';
import mobilePersonIcon from '../assets/images/mobile-person-icon.png';
import mobileLockIcon from '../assets/images/mobile-lock-icon.png';
import mobileEyeOffIcon from '../assets/images/mobile-eye-off-icon.png';

/** Same host→logo map as desktop CompanyLogin. */
const getBranchLogoForHost = () => {
  if (typeof window === 'undefined') return GDC_logo;
  const host = window.location.hostname.toLowerCase();
  if (host === 'mxhealth.americanhospital.qa' || host === 'amhctest.magunex.com') {
    return amhc_logo;
  }
  if (
    host === 'mxhealthdemo.magunex.com' ||
    host === 'test.magunex.com' ||
    host === 'mxqtest.magunex.com'
  ) {
    return MGE;
  }
  if (host === 'gdcfmp.magunex.com' || host === 'gdcfmptest.magunex.com') {
    return GDC_logo;
  }
  if (host === 'hayapptest.magunex.com') {
    return hayat_logo;
  }
  return MGE;
};

/**
 * RD link-flow company login — /auth/rd-company-login only.
 * Does not share UI with desktop /auth/company-login.
 */
const RdCompanyLogin = () => {
  const { loginCompany, alert } = useContext(CompanyContext);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState({
    coLicenseKey: '',
    cpPassword: '',
  });
  const [errors, setErrors] = useState({});
  const branchLogo = getBranchLogoForHost();

  const handleLogin = (e) => {
    e.preventDefault();
    loginCompany(userData, validateCompanyUser, setErrors, navigate);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedUserData = { ...userData, [name]: value };
    setUserData(updatedUserData);
    setErrors(validateCompanyUser(updatedUserData));
  };

  return (
    <div style={styles.pageWrapper} className="bl-pageWrapper page-wrapper bl-authMobileUrl">
      <div style={styles.leftPanel} className="bl-leftPanel">
        <div style={styles.overlay} className="animate-fade-in-up">
          <h2 style={styles.signInTitle}>Mx. Health</h2>
          <p style={styles.subText}>Sign in to your company</p>
          <img src={Productlogo} className="bl-productLogo" alt="recreatedSvg" />
        </div>
      </div>

      <div style={styles.rightPanel} className="bl-rightPanel">
        <div style={styles.loginBox} className="bl-loginBox">
          <div className="bl-logoTop bl-rdCompanyLogo animate-slide-in-left">
            <img src={branchLogo} alt="Company Logo" className="bl-logoImg" />
          </div>

          <div className="bl-mobileWelcome">
            <h2 className="bl-mobileWelcomeTitle">Welcome back,</h2>
            <p className="bl-mobileWelcomeSub">Sign in to your account to continue</p>
          </div>

          {alert.show && (
            <div
              style={{
                color: alert.type === 'error' ? 'red' : 'green',
                marginBottom: '10px',
              }}
            >
              {alert.message}
            </div>
          )}

          <form onSubmit={handleLogin} style={styles.form} className="bl-form">
            <div className="bl-inputWrap animate-slide-in-left">
              <img src={mobilePersonIcon} alt="" className="bl-inputIcon bl-mobileOnly" />
              <input
                type="text"
                name="coLicenseKey"
                placeholder="Company ID"
                value={userData.coLicenseKey}
                onChange={handleChange}
                autoComplete="off"
                style={styles.input}
                className="bl-input bl-mobilePlaceholderCompanyId"
              />
            </div>
            {errors.coLicenseKey && <small style={styles.error}>{errors.coLicenseKey}</small>}

            <div
              style={{ position: 'relative', marginBottom: '20px' }}
              className="bl-inputWrap bl-passwordWrap animate-slide-in-left"
            >
              <img src={mobileLockIcon} alt="" className="bl-inputIcon bl-mobileOnly" />
              <input
                type={showPassword ? 'text' : 'password'}
                name="cpPassword"
                placeholder="Password"
                value={userData.cpPassword}
                onChange={handleChange}
                autoComplete="off"
                style={{
                  ...styles.input,
                  paddingRight: '40px',
                  marginTop: 0,
                  marginBottom: 0,
                }}
                className="bl-input bl-passwordInput bl-mobilePlaceholderPassword"
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                }}
                className="bl-eye"
              >
                <img
                  src={showPassword ? Eye : mobileEyeOffIcon}
                  alt={showPassword ? 'Hide Password' : 'Show Password'}
                  className="bl-eyeImg bl-mobileOnly"
                />
              </span>
            </div>
            {errors.cpPassword && <small style={styles.error}>{errors.cpPassword}</small>}

            <button
              type="submit"
              className="animate-slide-in-left gradient-button bl-button"
              style={{
                position: 'relative',
                display: 'inline-block',
                padding: '15px 40px',
                fontSize: '18px',
                fontWeight: '700',
                color: '#fff',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                border: 'none',
                borderRadius: '2px',
                cursor: 'pointer',
                background: 'linear-gradient(45deg, #1A7F8E, #28a19a, #116466)',
                backgroundSize: '300% 300%',
                boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
                transition: 'all 0.3s ease',
                overflow: 'hidden',
              }}
            >
              Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

const styles = {
  pageWrapper: {
    display: 'flex',
    height: '100%',
    width: '100%',
    margin: 0,
    padding: 0,
    fontFamily: "'Urbanist', sans-serif",
    overflow: 'hidden',
  },
  leftPanel: {
    flex: 1,
    height: '100%',
    backgroundImage: `url(${loginlogo})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  overlay: {
    padding: '60px 40px',
    maxWidth: '600px',
    color: '#fff',
  },
  signInTitle: {
    fontSize: '36px',
    fontWeight: 700,
    marginBottom: '15px',
  },
  subText: {
    fontSize: '24px',
    lineHeight: 1.5,
    fontWeight: 400,
  },
  rightPanel: {
    flex: 1,
    height: '100%',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  loginBox: {
    width: '80%',
    maxWidth: '650px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    padding: '0px 40px',
    borderRadius: '10px',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    width: '100%',
    height: '50px',
    padding: '12px 15px',
    borderRadius: '6px',
    border: '2px solid #ccc',
    fontSize: '16px',
    boxSizing: 'border-box',
    marginBottom: '10px',
    color: 'lightgray',
  },
  error: {
    color: 'red',
    fontSize: '12px',
    marginBottom: '10px',
  },
};

export default RdCompanyLogin;
